import { BlockBorderProps } from "@store/Components/Common/Block/Block";

export const defaultBorderProps: BlockBorderProps = {
    width: "1px",
    type: "solid",
    color: "common.border",
};
